/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

export function LatestAMP({ color = "#c0c0c0" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.67 64.67">
      <defs />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <circle
            className="cls-1"
            cx="32.33"
            cy="32.33"
            r="31.33"
            fill="none"
            stroke="#707070"
            strokeMiterlimit={10}
            strokeWidth={3}
          />
          <polygon
            className="cls-2"
            fill="none"
            stroke="#e92227"
            strokeWidth={4}
            strokeMiterlimit={10}
            points="42.77 41.6 28.67 34.58 28.67 14.81 32.67 14.81 32.67 32.11 44.56 38.02 42.77 41.6"
          />
        </g>
      </g>
    </svg>
  );
}
LatestAMP.propTypes = {
  color: PropTypes.string
};
